import styled from 'styled-components';
import { Button, Typography } from 'antd';

const PRIMARY_COLOR = '#F04D00';

const { Text, Title } = Typography;

const SectionLabel = styled.p`
  text-transform: uppercase;
  letter-spacing: 1px;
  font-size: 11px;
  color: #888;
  font-weight: 600;
  margin-bottom: 8px;
`;

const TodayLocationLabel = styled(Text)`
  color: ${PRIMARY_COLOR};
  text-transform: uppercase;
  letter-spacing: 1.5px;
  font-size: 11px;
  font-weight: 700;
`;

const GreetingTitle = styled(Title)`
  margin-top: 4px !important;
  margin-bottom: 2px !important;
`;

const QuestionTitle = styled(Title)`
  margin-top: 16px !important;
  margin-bottom: 14px !important;
`;

const LastRecordBanner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  background: #FEF0EC;
  border: 1px solid ${PRIMARY_COLOR};
  border-radius: 8px;
  padding: 10px 14px;
  margin-bottom: 20px;
`;

const SuccessLocationText = styled.div`
  color: ${PRIMARY_COLOR};
  font-size: 17px;
  font-weight: 700;
  margin-top: 4px;
`;

const HeadquarterButton = styled(Button)`
  ${({ $selected }) => $selected ? `
    background: #000 !important;
    border-color: #000 !important;
    color: #fff !important;
  ` : ''}
`;

const SuggestedLabel = styled.span`
  position: absolute;
  bottom: 4px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
  font-size: 8px;
  color: ${PRIMARY_COLOR};
  font-weight: 700;
  letter-spacing: 0.5px;
  line-height: 1;
  white-space: nowrap;
`;

const WorkStationButton = styled(Button)`
  height: auto !important;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
  ${({ $selected }) => $selected ? `
    background: #FEF0EC !important;
    border-color: ${PRIMARY_COLOR} !important;
    color: ${PRIMARY_COLOR} !important;
  ` : ''}
`;

const SuccessIconCircle = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #f6ffed;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
`;

const SuccessTitle = styled.h2`
  font-size: 22px;
  font-weight: 700;
  text-align: center;
  margin: 0 0 6px;
  color: #1a1a1a;
`;

const SuccessSubtitle = styled.p`
  text-align: center;
  color: #888;
  margin: 0 0 4px;
  font-size: 14px;
`;

const EnterButton = styled(Button)`
  background: #1a1a1a !important;
  border-color: #1a1a1a !important;
  color: #fff !important;
  border-radius: 8px !important;
  height: auto !important;
  padding: 12px 0 !important;
  font-weight: 600 !important;
`;

export {
  PRIMARY_COLOR,
  SectionLabel,
  TodayLocationLabel,
  GreetingTitle,
  QuestionTitle,
  LastRecordBanner,
  SuccessLocationText,
  SuccessIconCircle,
  SuccessTitle,
  SuccessSubtitle,
  EnterButton,
  HeadquarterButton,
  SuggestedLabel,
  WorkStationButton,
};
